/*
 * UUID-Generierung für Projekte und Paragraphen.
 * Zentralisiert, damit alle Module dieselbe Methode verwenden.
 */

export function generateUUID() {
    return crypto.randomUUID()
}
